import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import IndexedDB from 'src/common/IndexedDB';
import Member from 'src/entities/Member';

import { updateMember } from '../../actions/member';
import Navigation from '../Navigation/global';

interface IProps {
  account: Member;
  updateMember: (member: Member) => void;
}

interface IState {
  account: Member;
}

class AccountComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      account: this.props.account
    };

    this.onChangeItem = this.onChangeItem.bind(this);
    this.onChangeIsMailable = this.onChangeIsMailable.bind(this);
    this.updateMember = this.updateMember.bind(this);
  }

  render() {
    return (
      <div id="AccountIndex">
        <Navigation isLogoOnly={true} />

        <div id="Tabs">
          <div className="Tab TabSelected">登録情報</div>
          <Link to="/settings/password">
            <div className="Tab">パスワード</div>
          </Link>
          <Link to="/settings/picture">
            <div className="Tab">画像</div>
          </Link>
        </div>
        <div id="Content">
          <div className="ContentItem">
            <label>従業員コード</label>
            <input
              className="InputText"
              value={this.state.account.id}
              disabled={true}
            />
          </div>

          <div className="ContentItem">
            <label>メール</label>
            <input
              className="InputText"
              value={this.state.account.email}
              onChange={this.onChangeItem.bind(this, 'email')}
            />
          </div>

          <div className="ContentItem">
            <label>電話番号</label>
            <input
              className="InputText"
              value={this.state.account.phone}
              onChange={this.onChangeItem.bind(this, 'phone')}
            />
          </div>

          <div className="ContentItem">
            <label>姓</label>
            <input
              className="InputText"
              value={this.state.account.nameLast}
              onChange={this.onChangeItem.bind(this, 'nameLast')}
            />
          </div>

          <div className="ContentItem">
            <label>名</label>
            <input
              className="InputText"
              value={this.state.account.nameFirst}
              onChange={this.onChangeItem.bind(this, 'nameFirst')}
            />
          </div>

          <div className="ContentItem">
            <label>メール通知</label>
            <input
              className="InputCheckbox"
              type="checkbox"
              onChange={this.onChangeIsMailable}
              checked={this.state.account.isMailable === false}
            />
            メール通知を許可しない
          </div>

          <button onClick={this.updateMember}>更新</button>
        </div>

        <button id="Logout" onMouseUp={this.logout} onTouchEnd={this.logout}>
          ログアウト
        </button>
      </div>
    );
  }

  onChangeItem(item: string, e: any) {
    const account = Object.assign({}, this.state.account);
    if (item === 'email') {
      account.email = e.target.value;
    } else if (item === 'phone') {
      account.phone = e.target.value;
    } else if (item === 'nameLast') {
      account.nameLast = e.target.value;
    } else if (item === 'nameFirst') {
      account.nameFirst = e.target.value;
    }

    this.setState({
      account
    });
  }

  onChangeIsMailable(e: any) {
    this.setState({
      account: {
        ...this.state.account,
        isMailable: !this.state.account.isMailable
      }
    });
  }

  updateMember(e: any) {
    this.props.updateMember(this.state.account);
    alert('更新されました');
  }

  logout(e: any) {
    const db = new IndexedDB();
    db.remove('auth');
    location.reload();
  }
}

const mapStateToProps = (state: any) => ({
  account: state.Account
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateMember(member: Member) {
      dispatch(updateMember(member));
    }
  };
};

const Memo = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountComponent);

export default Memo;



// WEBPACK FOOTER //
// ./src/components/Account/index.tsx